import { Modal } from "ant-design-vue";
import lodash from "lodash";
import moment from "moment";
import { setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import {
    createFieldInput,
    createFieldInputNumber,
    createFieldSelect,
    createFieldTextArea
} from "../../../../components/input/template-builder/template-builder.logic";
import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import router from "../../../../router";
import store from "../../../../store";
import { conditionFormChecker, copyForm, putField } from "../../../../utils/form";
import { has } from "../../../../utils/menu-context";
import { callRequestDoc, callRequestStatus, callRequestType } from "../../storage-location/request/request.section";
import { callUser, checkUserCompanyOperation } from "../../storage-location/request/requestor/requestor.section";
import { sumUserArea } from "./haz-license-storage-location/haz-license-storage-location.logic";
import { defineAsyncComponent } from "vue";
import { dateFormat } from "../../../../utils/date";

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const callUserObjective = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery })
        .then(items => items.filter(item => ["1", "2", "4", "5"].includes(item.key)));
export const callQuantityUnit = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "QUANTITY_UNIT", value: searchQuery });
export const callHazLicenseObjective = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_LICENSE_OBJECTIVE", value: searchQuery });
export const callCountry = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/country/cacheFindAll", {
            where: [
                { name: "nameEnS", type: "String", operator: "like", value: searchQuery },
                { logic: "OR", name: "nameTh", operator: "like", value: searchQuery }
            ],
            sort: [{ name: "seq", type: "ASC" }]
        })
        .then(items => items.map(item => ({ refCountry: item })));

export const callHazLicense = ({ searchQuery, routerPrefix, userInfo, isOfficerCreate, expireDate, requestTypeKey }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "refSpecies.key", type: "String", operator: "=", value: routerPrefix === "haz-license-requests" ? "3" : "2" }
    ];

    if (requestTypeKey === "3") {
        where.push({ name: "expireDate", type: "Date", operator: "<=", value: expireDate ? expireDate : moment().add(3, "months").format("YYYY-MM-DD") })
        where.push({ openBucket: true, name: "isRenewed", type: "Boolean", operator: "=", value: false })
        where.push({ closeBucket: true, logic: "OR", name: "isRenewed", type: "Boolean", operator: "=", value: null })
    } else {
        where.push({ name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") })
    }

    if (!isOfficerCreate) {
        where.push(
            { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 1
            { name: "refUserCompany.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },

            { logic: "OR", openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { name: "refUserCompany.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "refUserCompany.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "refUserCompany.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "refUserCompany.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "2" },
            { name: "refUserCompany.userAuthorizes.refAuthorize.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },

            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "1" },
            {
                name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refAuthorize.id",
                type: "Getpath",
                operator: "=",
                value: "refUserCompany.id"
            },
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" } // 1
        );
    }
    if (expireDate) {
        where.push({ name: "expireDate", type: "Date", operator: "<=", value: expireDate });
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }

    return store
        .dispatch("resource/v1/transaction/hazLicense/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode", "refOperation.key", "refOperation.value", "refUserCompany.id", "refUserCompany.fullNameTh", "expireDate"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }],
                children: [
                    {
                        name: "hazLicenseDetails",
                        select: ["*", "refHaz.refOperation.*", "refHaz.id", "refHaz.effectiveDate", "refHaz.expireDate", "refHaz.approveCode", "refHaz.approveCode2"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    },
                ]
            }
        })
        .then(page => page.data);
};
export const callHazLicenseFull = ({ id }) => {
    return store
        .dispatch("resource/v1/transaction/hazLicense/search", {
            criteria: {
                isDistinct: true,
                select: ["**", "refUserCompany.refPersonType.*", "refUser.refPersonType.*"],
                page: 0,
                size: 1,
                where: [{ name: "id", type: "UUID", operator: "=", value: id }],
                children: [
                    { name: "attachments", select: ["**"], page: 0, size: 1000000, sort: [{ name: "createDate", type: "ASC" }] },
                    {
                        name: "refUserCompany.addresses",
                        select: ["**"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "refUser.addresses",
                        select: ["**"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "hazLicenseDetails",
                        select: ["*", "refHaz.refOperation.*", "refHaz.refHazObject.refSpecies.*", "refHaz.refManufactureCountry.*"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    },
                    {
                        name: "hazLicenseStorageLocations",
                        select: ["*", "refStorageLocation.**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                        children: [
                            {
                                name: "refStorageLocation.subs",
                                select: ["**"],
                                page: 0,
                                size: 1000000,
                                sort: [{ name: "createDate", type: "ASC" }],
                                children: []
                            },
                            {
                                name: "refStorageLocation.addresses",
                                select: ["**"],
                                page: 0,
                                size: 1000000,
                                sort: [{ name: "createDate", type: "ASC" }],
                                children: []
                            }
                        ]
                    },
                    {
                        name: "hazLicenseCountries",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    }
                ]
            }
        })
        .then(page => page.data[0]);
};

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.hazLicense.refUserCompany"),
            dataIndex: "refHazLicenseTemp.refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refHazLicenseTemp?.refUserCompany?.refPersonType?.key === "1"
                    ? record.refHazLicenseTemp?.refUserCompany?.companyNameTh
                    : record.refHazLicenseTemp?.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({ title: () => i18n.global.t("model.request.requestCode"), dataIndex: "requestCode", align: "center" }),
        // createColumnInput({
        //     title: () => i18n.global.t("views.request.approveCode"),
        //     dataIndex: "refHazLicense.approveCode",
        //     align: "center"
        // }),
        // createColumnDate({
        //     title: () => i18n.global.t("model.hazLicense.expireDate"),
        //     dataIndex: "refHazLicense.expireDate",
        //     customRender: ({ record }) => (<>
        //         <div className={ record.refHazLicenseNew?.expireDate ? "line_through" : ""}>
        //             { dateFormat({ text: record.refHazLicense?.expireDate, format: "DD/MM/YYYY" }) }
        //         </div>
        //         <div>{ dateFormat({ text: record.refHazLicenseNew?.expireDate, format: "DD/MM/YYYY" }) }</div>
        //     </>),
        //     align: "center"
        // }),
        createColumnInput({
            title: () => i18n.global.t("views.request.approveCode"),
            dataIndex: "refHazLicenseMax.approveCode",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.hazLicense.expireDate"),
            dataIndex: "refHazLicenseMax.expireDate",
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazLicense.refOperation"),
            dataIndex: "refHazLicenseTemp.refOperation.value",
            inputProp: () => ({ list: callUserObjective, optLabel: "value" }),
            align: "center",
            search: { name: "refHazLicenseTemp.refOperation.id" }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazLicense.refHaz"),
            dataIndexValue: ({ record }) => record.refHazLicenseTemp?.hazLicenseDetails?.map(itemName => itemName.refHaz.approveCode).join(", "),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { name: "refHazLicenseTemp.hazLicenseDetails.refHaz.approveCode" }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazLicense.refHazName"),
            dataIndexValue: ({ record }) =>
                record.refHazLicenseTemp?.hazLicenseDetails?.map(itemName => itemName.refHaz.refHazObject.nameTh).join(", "),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refRequestType"),
            dataIndex: "refRequestType.value",
            customRender: ({ record }) => <div>
                <span>{record.refRequestType?.value}</span>
                {record.isSignCa ? <CIcon class="ml-1" file="sign.svg"></CIcon> : null}
            </div>,
            inputProp: () => ({ list: callRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callRequestStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ props, data, refs, key }) => {
    const { viewOnly, routerPrefix } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    data.onUpdateRefOperation = createOnUpdateRefOperation({ props, data, refs, key });
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) =>
                    conditionFormChecker({
                        props,
                        data,
                        executeKey: "visibleField",
                        params: { field }
                    }),
                key: `${prefix}refRequestType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refRequestType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequestType,
                            "onUpdate:value": value => {
                                const oldValue = model.refRequestType;
                                model.refRequestType = value;
                                if (
                                    (["2"].includes(oldValue?.key) || (!["1"].includes(oldValue?.key) && ["1"].includes(value?.key))) &&
                                    model.refHazLicense
                                ) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", { text: i18n.global.t("model.request.refRequestType") }),
                                        autoFocusButton: "cancel",
                                        onOk: () => {
                                            if (["1", "3"].includes(value?.key)) {
                                                const { createForm } = require("./request.logic");
                                                cloneHazLicense({
                                                    props,
                                                    model: {
                                                        ...createForm({ props, data, refs }),
                                                        id: model.id,
                                                        version: model.version,
                                                        isActive: model.isActive,
                                                        refStatus: model.refStatus,
                                                        refRequestDoc: model.refRequestDoc,
                                                        draftCode: model.draftCode,
                                                        requestCode: model.requestCode
                                                    }
                                                });
                                            } else {
                                                cloneHazLicense({ props, model, id: model.refHazLicense?.id });
                                            }
                                        },
                                        onCancel: () => {
                                            model.refRequestType = oldValue;
                                        }
                                    });
                                }
                            },
                            disabled: viewOnly,
                            list: callRequestType,
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazLicense`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazLicense.approveCode"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refHazLicense,
                            "onUpdate:value": value => {
                                const oldValue = model.refHazLicense;
                                model.refHazLicense = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.hazLicense.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneHazLicense({ props, model, id: value?.id }),
                                        onCancel: () => {
                                            model.refHazLicense = oldValue;
                                        }
                                    });
                                } else {
                                    cloneHazLicense({ props, model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callHazLicense({
                                    routerPrefix,
                                    searchQuery,
                                    userInfo: store.state.resource.auth.info?.user,
                                    isOfficerCreate: model.isOfficerCreate,
                                    requestDocKey: model.refRequestDoc?.key,
                                    requestTypeKey: model.refRequestType?.key,
                                    expireDate:
                                        model.refRequestDoc?.key && model.refRequestType?.key === "3"
                                            ? moment()
                                                  .add(model.refRequestDoc.attribute.renew, model.refRequestDoc.attribute.renewUnit)
                                                  .format("YYYY-MM-DD")
                                            : null
                                }).then((res) => {
                                        // loop for check disabled item
                                        if (model.refRequestType?.key === "3") {
                                            res.forEach(d => {
                                                const today = moment().startOf('day');
                                                d.disabled = d.expireDate && today.isAfter(moment(d.expireDate))
                                                    || d.hazLicenseDetails?.some(d2 => today.isAfter(moment(d2.refHaz.expireDate)));
                                            });
                                        }
                                        return res;
                                }),
                            renderLabel: ({ item }) => {
                                let expire = item.expireDate ? ` (Expire: ${dateFormat({ text: item.expireDate, format: "DD/MM/YYYY" })})` : ''
                                const operation = item.refOperation?.value ? ` - ${item.refOperation?.value}` : ''

                                const today = moment().startOf('day');
                                const hazExpires = item.hazLicenseDetails?.filter(d => today.isAfter(moment(d.refHaz.expireDate))) || [];
                                if (hazExpires.length > 0) {
                                    const hazIds = hazExpires.map(h => `${h.refHaz.approveCode} (${dateFormat({ text: h.refHaz.expireDate, format: "DD/MM/YYYY" })})`).join(", ");
                                    expire += ` (HAZ Expired: ${hazIds})`;
                                }
                                return <div>{item.approveCode}{expire}{operation} - {item.refUserCompany?.fullNameTh}</div>
                            },
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => (model.refHazLicenseNew?.approveCode && model.refHazLicenseNew?.expireDate) && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazLicenseNew.approveCode`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.hazLicense.info.approveCodeNew")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: `${model.refHazLicenseNew.approveCode} (ExpireDate: ${dateFormat({ text: model.refHazLicenseNew.expireDate, format: "DD/MM/YYYY" })})`,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forRequestRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToOfficer"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forRequestRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forRequestRemark[0].remark = value),
                            disabled: viewOnly || model.isOfficerCreate
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forReceiveRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToUserCompany"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forReceiveRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forReceiveRemark[0].remark = value),
                            disabled: viewOnly || model.isOfficerCreate
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazLicenseTemp.refOperation`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.haz.refOperation"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazLicenseTemp.refOperation,
                            "onUpdate:value": data.onUpdateRefOperation,
                            disabled: viewOnly || !model.refHazLicenseTemp.refUserCompany,
                            list: ({ searchQuery }) =>
                                callUserObjective({ searchQuery }).then(items =>
                                    checkUserCompanyOperation({ operations: items, userCompany: model.refHazLicenseTemp.refUserCompany })
                                ),
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazLicenseTemp.quantity`,
                colProp: () => ({ xs: 24, md: 16 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => `${i18n.global.t("model.hazLicense.quantity")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazLicenseTemp.quantity,
                            "onUpdate:value": value => (model.refHazLicenseTemp.quantity = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazLicenseTemp.refQuantityUnit`,
                colProp: () => ({ xs: 24, md: 8 }),
                label: () => `${i18n.global.t("model.hazLicense.refQuantityUnit")}`,
                labelRender: () => "",
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazLicenseTemp.refQuantityUnit,
                            "onUpdate:value": value => (model.refHazLicenseTemp.refQuantityUnit = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callQuantityUnit({ searchQuery }).then(items => items.filter(d => ["KGM", "LTR"].includes(d.key))),
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazLicenseTemp.hazLicenseCountries`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazLicense.hazLicenseCountries"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazLicenseTemp.hazLicenseCountries,
                            "onUpdate:value": value => (model.refHazLicenseTemp.hazLicenseCountries = value),
                            disabled: viewOnly,
                            list: callCountry,
                            renderLabel: ({ item }) => (
                                <span>
                                    {item.refCountry.nameEnS} : {item.refCountry.nameTh}
                                </span>
                            ),
                            mode: "multiple",
                            canCheckAll: true,
                            optKey: "refCountry.id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazLicenseTemp.specificArea`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.hazLicense.specificArea")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazLicenseTemp.specificArea,
                            "onUpdate:value": value => (model.refHazLicenseTemp.specificArea = value),
                            disabled: true,
                            suffix: () => <div>{i18n.global.t("model.hazLicense.m2")}</div>
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazLicenseTemp.refHazLicenseObjective`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazLicense.refHazLicenseObjective"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazLicenseTemp.refHazLicenseObjective,
                            "onUpdate:value": value => (model.refHazLicenseTemp.refHazLicenseObjective = value),
                            disabled: viewOnly,
                            list: callHazLicenseObjective,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazLicenseTemp.transportation`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.hazLicense.transportation")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazLicenseTemp.transportation,
                            "onUpdate:value": value => (model.refHazLicenseTemp.transportation = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazLicenseTemp.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazLicense.remark"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazLicenseTemp?.remark,
                            "onUpdate:value": value => (model.refHazLicenseTemp.remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            })
        ]
    });
};

export const cloneHazLicense = ({ props, model, id }) => {
    const { menuContext } = props;
    if (id) {
        setIsLoadingApp(true);
        callHazLicenseFull({ id })
            .then(hazLicense => {
                const refHazLicenseTemp = copyForm({ form: { ...hazLicense, isTemp: true } });
                if (id) {
                    refHazLicenseTemp.attachments.forEach((d, index) => (d.refRealId = hazLicense.attachments[index].id));
                    refHazLicenseTemp.hazLicenseDetails.forEach((d, index) => (d.refReal = { id: hazLicense.hazLicenseDetails[index].id }));
                    refHazLicenseTemp.hazLicenseStorageLocations.forEach(
                        (d, index) => (d.refReal = { id: hazLicense.hazLicenseStorageLocations[index].id })
                    );
                    refHazLicenseTemp.hazLicenseCountries.forEach((d, index) => (d.refReal = { id: hazLicense.hazLicenseCountries[index].id }));
                }
                return  Promise.all([
                    callRequestDoc({}),
                    callUser({ userCompanyId: refHazLicenseTemp.refUserCompany.id })
                ]).then(arr => {
                    const items = arr[0];
                    model.refRequestDoc = items.find(item => {
                        if (has({ menuContext, key: "forHazLicenseNotice" })) {
                            if (
                                (refHazLicenseTemp?.refOperation?.key === "1" && item.key === "12") ||
                                (refHazLicenseTemp?.refOperation?.key === "4" && item.key === "14") ||
                                (refHazLicenseTemp?.refOperation?.key === "2" && item.key === "13") ||
                                (refHazLicenseTemp?.refOperation?.key === "5" && item.key === "15")
                            ) {
                                return item;
                            }
                        } else {
                            if (
                                (refHazLicenseTemp?.refOperation?.key === "1" && item.key === "08") ||
                                (refHazLicenseTemp?.refOperation?.key === "4" && item.key === "10") ||
                                (refHazLicenseTemp?.refOperation?.key === "2" && item.key === "09") ||
                                (refHazLicenseTemp?.refOperation?.key === "5" && item.key === "11")
                            ) {
                                return item;
                            }
                        }
                    });

                    const users = arr[1];
                    refHazLicenseTemp.refUser = users.find(d => d.id === store.state.resource.auth.info?.user?.id) || refHazLicenseTemp.refUser;
                    router.push({
                        name: router.currentRoute.value.name,
                        params: { props: JSON.stringify({ form: { ...model, refDepartment: hazLicense.refDepartment, refHazLicenseTemp } }) },
                        query: { _timestamp: new Date().getTime() }
                    });
                })
            })
            .finally(() => setIsLoadingApp(false));
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};

export const createOnUpdateRefOperation = ({ props, data, key }) => {
    const { menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    return value => {
        model.refHazLicenseTemp.refOperation = value;
        model.refHazLicenseTemp.quantity = null;
        model.refHazLicenseTemp.specificArea = null;
        model.refHazLicenseTemp.transportation = null;
        model.refHazLicenseTemp.remark = null;
        lodash.remove(model.refHazLicenseTemp.hazLicenseDetails, row => !row.id);
        model.refHazLicenseTemp.hazLicenseDetails.forEach(row => (row.isDelete = true));
        lodash.remove(model.refHazLicenseTemp.hazLicenseCountries, row => !row.id);
        model.refHazLicenseTemp.hazLicenseCountries.forEach(row => (row.isDelete = true));
        model.refHazLicenseTemp.hazLicenseStorageLocations.forEach(row => {
            if (row.refStorageLocation?.isLocation === false) {
                if (row.id) {
                    row.isDelete = true;
                } else {
                    const foundIndex = model.refHazLicenseTemp.hazLicenseStorageLocations.findIndex(item => lodash.isEqual(item, row));
                    model.refHazLicenseTemp.hazLicenseStorageLocations.splice(foundIndex, 1);
                }
            }
        });
        if (value) {
            callRequestDoc({}).then(items => {
                model.refRequestDoc = items.find(item => {
                    if (has({ menuContext, key: "forHazLicenseNotice" })) {
                        if (
                            (value.key === "1" && item.key === "12") ||
                            (value.key === "4" && item.key === "14") ||
                            (value.key === "2" && item.key === "13") ||
                            (value.key === "5" && item.key === "15")
                        ) {
                            return item;
                        }
                    } else {
                        if (
                            (value.key === "1" && item.key === "08") ||
                            (value.key === "4" && item.key === "10") ||
                            (value.key === "2" && item.key === "09") ||
                            (value.key === "5" && item.key === "11")
                        ) {
                            return item;
                        }
                    }
                });
            });
        } else {
            model.refRequestDoc = null;
        }

        if (model.refHazLicenseTemp?.refOperation?.key === "5") {
            const items = model.refHazLicenseTemp.hazLicenseStorageLocations;
            model.refHazLicenseTemp.specificArea = sumUserArea({ items });
        }
    };
};
